import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipsGroup from '../../../../../../common/inputs/chipsGroup/ChipsGroup'
import { getRentDurations } from '../../../../../../../services/domain/getRentDurations'

const Deposit: React.FC<FieldProps<CostsScreenValidationResult>> = ({ insertionData, onChange, screenName }) => {
  const { t } = useTranslation()
  return (
    <div className='grid-item margin-top-l'>
      <span className='font-body-medium-bold'>{t('wizard.screen.costs.rentalDuration', 'Rental duration')}</span>
      <span className='font-body-small-regular font-lightgray margin-left'>
        {t('wizard.screen.costs.hint', 'Multiple selection possible')}
      </span>
      <ChipsGroup
        id={'rent-duration'}
        className='gutter-xs margin-top-xs'
        features={getRentDurations(insertionData)}
        translation='wizard.screen.costs.'
        onChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default Deposit
